export default `float i,g,e,R,S;
    vec3 q;
    p.z-=3.;
    q=p; R=1.;
    for(int j=0;j++<9;)
      p-=clamp(p,-.9,.9)*2.,
      S=9.*clamp(.1/min(dot(p,p),1.),0.,1.),
      p=p*S+q, R=R*S+1.;
    return .7*length(p)/R;
  }`